import { render, staticRenderFns } from "./OrganizerRegistrationSuccess.vue?vue&type=template&id=13f195f6&scoped=true&"
import script from "./OrganizerRegistrationSuccess.vue?vue&type=script&lang=js&"
export * from "./OrganizerRegistrationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./OrganizerRegistrationSuccess.vue?vue&type=style&index=0&id=13f195f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f195f6",
  null
  
)

export default component.exports